<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <vs-card>
      <vs-table search stripe :data="licencas">
        <template slot="header">
          <vs-button
            v-if="canAddAttendance"
            @click="popupAdd = true"
            icon-pack="feather"
            icon="icon-plus"
            color="primary"
            type="border"
            class="mb-2"
            >Adicionar Licença</vs-button
          >
        </template>
        <template slot="thead">
          <vs-th sort-key="name">Nome</vs-th>
          <vs-th sort-key="email">Licença</vs-th>
          <vs-th sort-key="email">Data Inicial</vs-th>
          <vs-th>Data Final</vs-th>
          <!-- <vs-th sort-key="email">Hora Inicio/Fim</vs-th> -->
          <vs-th sort-key="email">Dedução</vs-th>
          <vs-th sort-key="email">Duração</vs-th>
          <vs-th sort-key="email">Descrição</vs-th>
          <vs-th sort-key="email">Anexo</vs-th>
          <vs-th sort-key="email">Estado</vs-th>
          <!-- <vs-th sort-key="email">Editar</vs-th> -->
          <!-- <vs-th sort-key="birth_date">Data de Nascimento</vs-th> -->
          <vs-th sort-key="birth_date">Ver</vs-th>
          <!-- <vs-th></vs-th> -->
          <!-- <vs-th sort-key="id">Nro</vs-th> -->
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].name">
              {{ data[indextr].name }}
              {{ data[indextr].surname }}
            </vs-td>

            <vs-td :data="data[indextr].type">
              <span v-if="data[indextr].type == 1">Doença do trabalhador </span>
              <span v-if="data[indextr].type == 2">Doença do dependente </span>
              <span v-if="data[indextr].type == 3"
                >Acidente do trabalhador</span
              >
              <span v-if="data[indextr].type == 4">Acidente do menor </span>
              <span v-if="data[indextr].type == 5">Maternidade </span>
              <span v-if="data[indextr].type == 6">Paternidade </span>
            </vs-td>
            <vs-td :data="data[indextr].amount">
              {{ data[indextr].start_date }}
           
            </vs-td>
            <!-- <vs-td>
              {{ formatTime(data[indextr].start_time) }} até <br />
              {{ formatTime(data[indextr].end_time) }}
            </vs-td> -->
            <vs-td :data="data[indextr].amount"> 
                 {{ data[indextr].end_date }}</vs-td>

            <vs-td :data="data[indextr].date">
              <span v-if="data[indextr].deduct_in == 'vacation'">Férias</span>
              <span v-if="data[indextr].deduct_in == 'salary'">Salário</span>
            </vs-td>

            <vs-td :data="data[indextr].date">
              {{ data[indextr].difference_in_days }}
              <span v-if="data[indextr].difference_in_days === 1">dia</span>
              <span v-else>dias</span>
            </vs-td>

            <vs-td>{{ data[indextr].description }}</vs-td>
            <vs-td>
              <vs-button
                v-if="data[indextr].attachment"
                target="_blank"
                size="small"
                iconPack="feather"
                color="success"
                icon="icon-download"
                :href="data[indextr].attachment"
              >
                Baixar
              </vs-button>
              <span v-else>Sem Anexo</span>
            </vs-td>
            <vs-td>
              <vs-chip
                v-if="data[indextr].status == 'created'"
                class="font-bold whitespace-no-wrap"
              >
                <div
                  class="h-2 w-2 rounded-full mr-1"
                  :class="'bg-primary'"
                ></div>
                <span>Criado</span>
              </vs-chip>

              <vs-chip
                v-if="data[indextr].status == 'pending'"
                class="font-bold whitespace-no-wrap"
              >
                <div
                  class="h-2 w-2 rounded-full mr-1"
                  :class="'bg-warning'"
                ></div>
                <span>pendente</span>
              </vs-chip>

              <vs-chip
                v-if="data[indextr].status == 'submeted'"
                class="font-bold whitespace-no-wrap"
              >
                <div
                  class="h-2 w-2 rounded-full mr-1"
                  :class="'bg-primary'"
                ></div>
                <span>Submetido</span>
              </vs-chip>
              <vs-chip
                v-if="data[indextr].status == 'approved'"
                class="font-bold whitespace-no-wrap"
              >
                <div
                  class="h-2 w-2 rounded-full mr-1"
                  :class="'bg-success'"
                ></div>
                <span>Aprovado</span>
              </vs-chip>
              <vs-chip
                v-if="data[indextr].status == 'rejected'"
                class="font-bold whitespace-no-wrap"
              >
                <div
                  class="h-2 w-2 rounded-full mr-1"
                  :class="'bg-warning'"
                ></div>
                <span>Rejeitado</span>
              </vs-chip>
              <vs-chip
                v-if="data[indextr].status == 'canceled'"
                class="font-bold whitespace-no-wrap"
              >
                <div
                  class="h-2 w-2 rounded-full mr-1"
                  :class="'bg-danger'"
                ></div>
                <span>Cancelado</span>
              </vs-chip>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <vs-row>
                <!-- <vs-button
                  :disabled="!canUpdatePayroll"
                  color="primary"
                  size="small"
                  hover:text-danger
                  icon-pack="feather"
                  icon="icon-edit"
                  @click="popupOpenEdit(tr)"
                >
                </vs-button> -->
                <!-- <vs-button :disabled="!canDeletePayroll" class="ml-2" color="danger"  type="border" size="small" icon-pack="feather" icon="icon-trash" @click="removeData(tr)"></vs-button> -->
                <!-- <vs-button
                  :disabled="!canDeletePayroll"
                  class="ml-2"
                  color="success"
                  size="small"
                  icon-pack="feather"
                  icon="icon-eye"
                  @click="getOpenApprove(tr)"
                ></vs-button> -->
                <vs-button
                  class="ml-1 mb-1"
                  color="success"
                  size="small"
                  icon-pack="feather"
                  icon="icon-log-in"
                  :to="{
                    name: 'licenceDetails',
                    params: {
                      licencaName: tr.name,
                      licencaLastName: tr.surname,
                      licencaId: tr.leave_id,
                      licencaTotalDiffTime: tr.total_diff_time,
                    },
                  }"
                >
                  Entrar
                </vs-button>
              </vs-row>
              <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
            </vs-td>
            <!-- <vs-td>
          
            </vs-td> -->

            <!-- <vs-td :data="data[indextr].id">
          {{ data[indextr].id }}
        </vs-td> -->
          </vs-tr>
        </template>
      </vs-table>
      <!-- <vs-pagination class="mt-3" :total="totalPage" @change="getEmployees" v-model="currentPage"></vs-pagination> -->
      <div
        style="height: 50px"
        id="div-with-loading"
        class="vs-con-loading__container"
      ></div>
    </vs-card>

    <vs-popup title="Aprovações" :active.sync="popupApprove">
      <div class="vx-row p-6">
        <!-- Coluna de Botões de Ação -->
        <div class="vx-col w-full mb-6">
          <div class="flex justify-center gap-4">
            <!-- Botão Submeter -->
            <vs-button
              v-if="status === 'created'"
              size="medium"
              color="primary"
              icon-pack="feather"
              icon="icon-check-circle"
              @click="
                status = 'submeted';
                saveApprove();
              "
            >
              Submeter
            </vs-button>

            <!-- Botão Aprovar -->
            <vs-button
              v-if="status === 'pending'"
              size="medium"
              color="success"
              icon-pack="feather"
              icon="icon-check-circle"
              @click="
                status = 'approved';
                saveApprove();
              "
            >
              Aprovar
            </vs-button>

            <!-- Botão Reprovar -->
            <vs-button
              v-if="status === 'pending'"
              size="medium"
              color="warning"
              icon-pack="feather"
              icon="icon-x-circle"
              @click="
                status = 'rejected';
                saveApprove();
              "
            >
              Reprovar
            </vs-button>

            <!-- Botão Cancelar -->
            <vs-button
              v-if="
                ['created', 'pending', 'approved', 'rejected'].includes(status)
              "
              size="medium"
              color="danger"
              :disabled="!canAddPayroll"
              @click="
                status = 'canceled';
                saveApprove();
              "
            >
              Cancelar
            </vs-button>
          </div>
        </div>

        <!-- Linha Divisória -->
        <hr class="my-6 border-gray-300" />

        <!-- Histórico de Aprovação -->
        <div class="vx-col w-full">
          <h3 class="text-lg font-semibold mb-4">Histórico de Aprovações</h3>
          <ul class="vx-timeline space-y-4">
            <template v-if="aprovacaoSelecionada.length === 0">
              <li class="text-center text-gray-500 mt-4">
                Sem histórico disponível
              </li>
            </template>
            <template v-else>
              <li
                v-for="historico in aprovacaoSelecionada"
                :key="historico.id"
                class="p-2 flex items-start space-x-4"
              >
                <!-- Ícone de Status -->
                <div
                  :class="{
                    'bg-warning': historico.status === 'rejected',
                    'bg-primary': historico.status === 'submeted',
                    'bg-danger': historico.status === 'canceled',
                    'bg-success': historico.status === 'approved',
                  }"
                  class="h-4 w-4 rounded-full flex-shrink-0"
                ></div>

                <!-- Detalhes do Histórico -->
                <div>
                  <!-- Texto de status e detalhes do usuário -->
                  <p class="font-semibold">
                    <span v-if="historico.status === 'rejected'"
                      >Reprovado</span
                    >
                    <span v-if="historico.status === 'submeted'"
                      >Submetido</span
                    >
                    <span v-if="historico.status === 'canceled'"
                      >Cancelado</span
                    >
                    <span v-if="historico.status === 'approved'">Aprovado</span>
                    por {{ historico.user.name }} {{ historico.user.surname }}
                  </p>

                  <!-- Observação -->
                  <p class="text-gray-600">{{ historico.observation }}</p>

                  <!-- Data e Hora -->
                  <small class="text-gray-500">
                    Data: {{ historico.created_at.slice(0, 10) }} às
                    {{ historico.created_at.slice(11, 16) }}
                  </small>
                </div>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </vs-popup>

    <vs-popup
      class="holamundo"
      title="Actualizar Licença"
      :active.sync="popupEdit"
    >
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Licença</label>
          <v-select
            v-validate="'required'"
            v-model="licenca.type"
            :reduce="(options) => options.id"
            :options="[
              { id: 1, label: 'Doença do trabalhador' },
              { id: 2, label: 'Doença do dependente' },
              { id: 3, label: 'Acidente do trabalhador' },
              { id: 4, label: 'Acidente do menor' },
              { id: 5, label: 'Maternidade' },
              { id: 6, label: 'Paternidade' },
            ]"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('motivo')">
            {{ errors.first("motivo") }}
          </span>
        </div>
        <div class="vx-col w-1/2 mb-5">
          <label for="">Data de início</label> <br />

          <vs-input
            class="w-full"
            type="date"
            v-model="licenca.start_date"
          ></vs-input>
        </div>
        <div class="vx-col w-1/2 mb-5">
          <label for="">Data de término</label> <br />

          <vs-input
            class="w-full"
            type="date"
            v-model="licenca.end_date"
          ></vs-input>
        </div>
        <div class="vx-col w-1/2 mb-5">
          <label for="">Hora de início</label> <br />

          <vs-input
            class="w-full"
            type="time"
            v-model="licenca.start_time"
          ></vs-input>
        </div>

        <div class="vx-col w-1/2 mb-5">
          <label for="">Hora de término</label> <br />
          <vs-input
            class="w-full"
            type="time"
            v-model="licenca.end_time"
          ></vs-input>
        </div>
        <div class="vx-col w-full mb-5">
          <label for="">Dedução</label> <br />

          <select
            v-model="licenca.deduct_in"
            class="w-full pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <option value="vacation">Nas ferias</option>
            <option value="salary">No salario</option>
          </select>
        </div>
        <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Descrição</label>
          <textarea
            class="w-full mt-2 mb-5 p-2 border rounded resize-y"
            v-model="licenca.description"
            rows="4"
            style="border-color: #ccc"
            placeholder="Insira a descrição aqui"
          ></textarea>
        </div>

        <div class="vx-col w-full mb-2">
          <div class="flex flex-wrap items-center flex-start">
            <vs-button class="ml-auto mt-2" @click="saveData">Salvar</vs-button>
            <vs-button
              class="ml-4 mt-2"
              type="border"
              color="warning"
              @click="popupEdit = false"
              >Cancelar</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup
      class="holamundo"
      title="Adicionar Licença"
      :active.sync="popupAdd"
    >
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <label class="mt-8" for=""
            >Funcionario:
            <strong
              >{{ selectedEmployee.name }}
              {{ selectedEmployee.surname }}</strong
            ></label
          >

          <v-select
            :label="'name'"
            class="mt-2"
            v-validate="'required'"
            v-model="selectedEmployee"
            :options="employees"
          >
          </v-select>
        </div>
        <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Licença</label>
          <v-select
            v-validate="'required'"
            v-model="type"
            :reduce="(options) => options.id"
            :options="[
              { id: 1, label: 'Doença do trabalhador' },
              { id: 2, label: 'Doença do dependente' },
              { id: 3, label: 'Acidente do trabalhador' },
              { id: 4, label: 'Acidente do menor' },
              { id: 5, label: 'Maternidade' },
              { id: 6, label: 'Paternidade' },
            ]"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('motivo')">{{
            errors.first("motivo")
          }}</span>
        </div>

        <div class="vx-col w-1/2 mb-5">
          <label for="">Data de início</label> <br />

          <vs-input class="w-full" type="date" v-model="start_date"></vs-input>
        </div>
        <div class="vx-col w-1/2 mb-5">
          <label for="">Data de término</label> <br />

          <vs-input class="w-full" type="date" v-model="end_date"></vs-input>
        </div>
        <!-- <div class="vx-col w-1/2 mb-5">
          <label for="">Hora de início</label> <br />

          <vs-input class="w-full" type="time" v-model="start_time"></vs-input>
        </div>

        <div class="vx-col w-1/2 mb-5">
          <label for="">Hora de término</label> <br />
          <vs-input class="w-full" type="time" v-model="end_time"></vs-input>
        </div> -->
        <div class="vx-col w-full mb-5">
          <label for="">Dedução</label> <br />

          <select
            v-model="deduct_in"
            class="w-full pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <option value="vacation">Nas ferias</option>
            <option value="salary">No salario</option>
          </select>
        </div>

        <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Descrição</label>
          <textarea
            class="w-full mt-2 mb-5 p-2 border rounded resize-y"
            v-model="description"
            rows="4"
            style="border-color: #ccc"
            placeholder="Insira a descrição aqui"
          ></textarea>
        </div>

        <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Ficheiro</label>
          <vs-input
            class="w-full mt-2 mb-2"
            type="file"
            v-model="ficheiro"
            name="file"
             @change="handleFileUpload"
          />
        </div>

        <div class="vx-col w-full mb-2">
          <div class="flex flex-wrap items-center flex-start">
            <vs-button class="ml-auto mt-2" @click="saveLicence"
              >Salvar</vs-button
            >
            <vs-button class="ml-4 mt-2" type="border" color="warning" @click="popupAdd = false"
              >Cancelar</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import http from "../../../../http-common";
import { PermissionsMixin } from "../../../mixins/permissions";
import VxTimeline from "@/components/timeline/VxTimeline.vue";
// Store Module

// Cell Renderer

export default {
  mixins: [PermissionsMixin],
  components: {
    vSelect,

    VxTimeline,
  },
  data() {
    return {
      attachment: "",
      licenca: [],
      historico: [],
      aprovacaoSelecionada: [],
      aprovacao: [],
      aprovacoes: [],
      licencas: [],
      deduct_in: "",
      start_date: "",
      start_time: "",
      end_date: "",
      end_time: "",
      description: "",
      totalPage: "",
      currentPage: "1",
      paginate: 50,
      amount: "",
      desconto: [],
      selectedEmployee: [],
      employees: [],
      popupAdd: false,
      popupEdit: false,
      name: "",
      abbreviation: "",
      type: "",
      components: [],
      component: [
        {
          id: "",
          name: "",
          abbreviation: "",
          type: "",
        },
      ],
      descontos: [],
      date: "",

      currentUser: [],
      dataActual: "",
      month: "",
      status: "",

      popupApprove: false,
    };
  },

  mounted() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.getData();
      this.getEmployees();
    },

    previewImage(event) {
      this.ficheiro = event.target.files[0];
    },
    handleFileUpload(event) {
      const file = event.target.files[0]; // Pega o primeiro arquivo (caso selecione apenas um)
      if (file) {
        this.ficheiro = file; 
      }
    },
    converterSegundos(segundos) {
      var dias = Math.floor(segundos / (3600 * 24)); // Calcula o número de dias
      var horas = Math.floor((segundos % (3600 * 24)) / 3600); // Calcula o número de horas

      return dias + " dias e " + horas + " horas";
    },
    formatTime(time) {
      // Verificar se o valor de time está no formato correto ou apenas hora (HH:MM)
      if (time) {
        const timeParts = time.split(":"); // Divida o valor em horas e minutos

        // Se o valor já for no formato HH:MM, use diretamente
        if (timeParts.length === 2) {
          return `${timeParts[0]}:${timeParts[1]}`;
        }

        // Caso contrário, crie um objeto Date com o valor formatado
        const date = new Date(`1970-01-01T${time}`);
        if (isNaN(date)) {
          return time; // Retorna o valor original se não for uma data válida
        }

        return date.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        });
      }
      return ""; // Caso o valor esteja vazio ou indefinido
    },

    getEmployees() {
      //  this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
        params: {
          page: this.currentPage,
          paginate: this.paginate,
          status: 1,
        },
      };

      http
        .get("/employees/employees", config)
        .then((result) => {
          this.employees = result.data.Employees.data.reverse();
          // this.currentPage="1",
          // this.totalPage = result.data.Employees.last_page;
          // this.total =  result.data.Employees.total;
        })
        .catch((error) => {
          error;
          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
        });
    },

    getOpenApprove(dados) {
      this.aprovacao = dados;
      this.status = dados.status;
      this.popupApprove = true;
      this.getApprove();
    },

    getApprove() {
      this.$vs.loading();
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get(`/attendances/leaves/${this.aprovacao.leave_id}`, config)
        .then((result) => {
          this.$vs.loading.close();
          this.aprovacaoSelecionada = result.data.Employee.approvals.reverse();
          console.log("Histórico do back", this.aprovacaoSelecionada);
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
        });
    },
    saveApprove() {
      // Inicia o loading
      this.$vs.loading();

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      const data = {
        status: this.status,
      };

      // Cria uma promessa para a requisição HTTP
      const requestPromise = http.post(
        `/attendances/leaves/approvals/${this.aprovacao.leave_id}`,
        data,
        config
      );

      // Cria uma promessa que será rejeitada após 2 segundos
      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error("Timeout")), 2000)
      );

      // Usa Promise.race para correr as duas promessas
      Promise.race([requestPromise, timeoutPromise])
        .then(() => {
          // Se a requisição for bem-sucedida, fecha o loading
          this.$vs.loading.close();
          this.popupApprove = false;

          // Chama os métodos para atualizar os dados
          this.getData();
          this.getEmployees();
        })
        .catch((error) => {
          // Fecha o loading em caso de erro (incluindo timeout)
          this.$vs.loading.close();

          // Fecha o popup após o erro ou timeout
          this.popupApprove = false;

          // Se for um erro de autorização, redireciona
          if (error.response && error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          } else {
            // Aqui você pode lidar com o erro de timeout ou outros erros
            console.error("Erro:", error.message); // Log do erro
          }
        });
    },

    getData() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 1.0,
        type: "sound",
      });

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get("/attendances/leaves", config)
        .then((result) => {
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          this.licencas = result.data.Leaves.data;
          // alert("2")
        })
        .catch((error) => {
          error;

          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
        });
    },

    async saveData() {
      console.log("licença:", this.licenca);
      console.log("start_date:", this.licenca.start_date);
      console.log("end_date:", this.licenca.end_date);
      this.$vs.loading();

      const startTimeFormatted = this.licenca.start_time
        .split(":")
        .slice(0, 2)
        .join(":");
      const endTimeFormatted = this.licenca.end_time
        .split(":")
        .slice(0, 2)
        .join(":");

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };

      const data = {
        deduct_in: this.licenca.deduct_in,
        start_date: this.licenca.start_date,
        start_time: startTimeFormatted,
        end_date: this.licenca.end_date,
        end_time: endTimeFormatted,
        type: this.licenca.type,
        description: this.licenca.description,
      };

      const url = `/attendances/update_leave/${this.licenca.leave_id}`;

      http
        .put(url, data, config)
        .then(() => {
          this.popupAdd = false;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Licença adicionada com sucesso!",
            color: "success",
            position: "top-right",
          });
          window.location.reload();
        })
        .catch((error) => {
          this.err = error.response.data;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        });
    },

    async saveLicence() {
      console.log("licença:", this.licenca);
      console.log("start_date:", this.licenca.start_date);
      console.log("end_date:", this.licenca.end_date);
      this.$vs.loading();

      // Formatar o horário para remover os segundos
      // const startTimeFormatted = this.start_time
      //   .split(":")
      //   .slice(0, 2)
      //   .join(":");
      // const endTimeFormatted = this.end_time.split(":").slice(0, 2).join(":");

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
          "content-type": "multipart/form-data",
        },
      };
      const data = new FormData();
      data.append("employee_id", this.selectedEmployee.id);
      data.append("deduct_in", this.deduct_in);
      data.append("start_date", this.start_date);
      data.append("start_time", "08:00"); // Usando o horário formatado
      data.append("end_date", this.end_date);
      data.append("end_time", "16:00"); // Usando o horário formatado

      // Enviar somente o `id` do tipo de licença
      data.append("type", this.type);

      data.append("description", this.description);
      data.append("attachment", this.ficheiro);

      http
        .post("/attendances/leaves", data, config)
        .then((success) => {
          success;

          (this.popupAdd = false), this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Licenca adicionada com sucesso!",
            color: "success",
            position: "top-right",
          });
          window.location.reload();
        })
        .catch((error) => {
          error;
          this.err = error.response.data;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        });
    },

    // popupOpenEdit(licenca) {
    //   (this.licenca = licenca), (this.popupEdit = true);
    // },
    popupOpenEdit(licenca) {
      const tiposLicenca = [
        { id: 1, label: "Doença do trabalhador" },
        { id: 2, label: "Doença do dependente" },
        { id: 3, label: "Acidente do trabalhador" },
        { id: 4, label: "Acidente do menor" },
        { id: 5, label: "Maternidade" },
        { id: 6, label: "Paternidade" },
      ];

      // Converte o `type` de string para número e encontra o tipo correspondente
      const tipoSelecionado = tiposLicenca.find(
        (option) => option.id === Number(licenca.type)
      );

      // Atribui somente o `id` ao `licenca.type` (sem o objeto completo)
      this.licenca = {
        ...licenca,
        type: tipoSelecionado ? tipoSelecionado.id : licenca.type,
      };
      this.popupEdit = true;
    },

    async editData() {
      //      this.$validator.validateAll().then(result => {
      // if (result) {
      this.$vs.loading();

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      const data = {
        date: this.desconto.date,
        amount: this.desconto.amount,
        reason: this.desconto.reason,
      };

      this.$validator.validateAll();
      http
        .put(`/salaries/disconts/${this.desconto.discount_id}`, data, config)
        .then((success) => {
          success;
          (this.popupEdit = false), this.getData(), this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Actualizado com sucesso!",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
          this.err = error.response.data;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        });
      // }})
    },
    async removeData(desconto) {
      (this.desconto = desconto), this.$vs.loading();

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      this.$validator.validateAll();
      http
        .delete(`/salaries/disconts/${this.desconto.discount_id}`, config)
        .then((success) => {
          success;
          (this.popupEdit = false), this.getData(), this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Removido com sucesso!",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
          this.err = error.response.data;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        });
      // }})
    },
  },
};
</script>
<style>
.text-center {
  text-align: center;
}

.mt-4 {
  margin-top: 2rem;
}
</style>
